/**
=========================================================
* NuDESC Course Content
* Nu-DESC assessment protocol course content
=========================================================
*/

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function NuDESCCourse() {
  return (
    <MDBox>
      <MDTypography variant="h6" color="white" mb={2}>
        NuDESC
      </MDTypography>
      <MDTypography variant="body2" color="white" opacity={0.8}>
        Course content for NuDESC will be displayed here.
      </MDTypography>
    </MDBox>
  );
}

export default NuDESCCourse;
